/** @format */

import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy redirect — the page lives at /race/$raceId/pre-race now. Keep
// this route file around so bookmarks and any stale external links land
// on the new page instead of a 404.
export const Route = createFileRoute("/race/$raceId/pre-race-stats")({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/race/$raceId/pre-race",
      params,
      search,
    });
  },
});
